import { useEffect } from 'react'
import MuiBox from '@mui/material/Box'
import { useFormik, Form, FormikProvider } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../../components/formik-control'
import { useAddSectionToLayoutMutation, useUpdateSectionInLayoutMutation } from '../../../slice'

const SectionForm = ({ campaign, section, onSubmitEvent, setSubmitEvent, setShowDrawer }) => {
  const [addSectionToLayout] = useAddSectionToLayoutMutation()
  const [updateSectionInLayout] = useUpdateSectionInLayoutMutation()

  const entityOptions = [
    { key: 'Prospects', value: 'prospects' },
    { key: 'Campaigns', value: 'campaigns' },
    { key: 'Clients', value: 'clients' },
  ]

  const initialValues = {
    id: section?.id,
    name: section?.name ?? '',
    entity: section?.entity ?? 'prospects',
    priority: section?.priority ?? 100,
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Required'),
    entity: Yup.string().required('Required'),
    priority: Yup.number().required('Required'),
  })

  const onSubmit = async (values) => {
    if (values.id)
      await updateSectionInLayout({
        campaignId: campaign.id,
        sectionId: values.id,
        section: {
          ...values,
          priority: parseInt(values.priority),
        },
      })
    else
      await addSectionToLayout({
        campaignId: campaign.id,
        section: {
          ...values,
          priority: parseInt(values.priority),
        },
      })
    setSubmitEvent()
    setShowDrawer(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  return (
    <FormikProvider value={formik}>
      <Form>
        <MuiBox>
          <FormikControl control="input" label="Name" name="name" fullWidth margin="normal" />
        </MuiBox>
        <MuiBox>
          <FormikControl
            control="select"
            label="Entity"
            name="entity"
            disabled={!!section?.id}
            options={entityOptions}
          />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="Priority" name="priority" fullWidth margin="normal" />
        </MuiBox>
      </Form>
    </FormikProvider>
  )
}

export default SectionForm
